import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function ArrowDown2Icon({
  className,
  style,
  active,
  ...props
}: IconProps & { active?: boolean }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <path
        d='M5 7.5L10 12.5L15 7.5'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
